import { TicketContact } from "@jugl-web/rest-api/tickets/models/common-types";
import {
  ResourcePickerPopover,
  ResourcePickerPopoverProps,
} from "@jugl-web/ui-components/web/ResourcePickerPopover";
import { useEntitySelectedProvider } from "@web-src/modules/entities/providers/EntityProvider/useEntitySelectedProvider";
import { FC, useState } from "react";
import { useContactListBox } from "../../pages/ClientSupportPage/components/IdentifyContactDialog/hooks/useContactListBox";

interface TicketContactPickerPopoverProps
  extends Pick<ResourcePickerPopoverProps<TicketContact>, "renderTrigger"> {
  contact: TicketContact | null;
  onChange: (contact: TicketContact) => void;
  onNewContactSelect: () => void;
}

export const TicketContactPickerPopover: FC<
  TicketContactPickerPopoverProps
> = ({ contact, onChange, onNewContactSelect, renderTrigger }) => {
  const { entityId } = useEntitySelectedProvider();

  const [isPopoverOpen, setIsPopoverOpen] = useState(false);

  const { getListBoxProps, clearSearchQuery } = useContactListBox({
    entityId,
    skipLoading: !isPopoverOpen,
    onNewContactSelect,
  });

  const handleSubmit = (newContact: TicketContact) => {
    if (newContact.id === contact?.id) {
      return;
    }

    onChange(newContact);
  };

  return (
    <ResourcePickerPopover
      placement="bottom"
      className="w-[312px]"
      renderTrigger={renderTrigger}
      onOpenStateChange={(isOpen) => {
        if (!isOpen) {
          clearSearchQuery();
        }
        setIsPopoverOpen(isOpen);
      }}
      onSelect={({ item, onClose }) => {
        handleSubmit({
          id: item.value.id,
          name: item.value.name ?? "Unknown",
        });
        onClose();
      }}
      {...getListBoxProps({
        itemSize: "md",
        spaceBetweenItems: "compact",
        defaultSelectedIds: contact ? [contact.id] : [],
      })}
    />
  );
};
